import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M15.56.377a.944.944 0 0 0-1.296.29L5.94 13.764 1.653 9.51a.94.94 0 0 0-.715-.33.944.944 0 0 0-.939.938.94.94 0 0 0 .34.723l4.439 4.41c.317.326.75.51 1.205.513q.09.006.179 0a1.7 1.7 0 0 0 1.24-.794l8.45-13.292A.94.94 0 0 0 15.56.377" />
  </svg>
);
const SvgCheckmark = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="checkmark" {...props} />;
export default SvgCheckmark;
